<div class="db-rating-stars">
  <span *ngFor="let star of stars">
    <i class="db-icon db-icon-star active" [ngStyle]="{width: star + '%'}"></i>
    <i class="db-icon db-icon-star-border" ></i>
  </span>
</div>
